import xtend from 'xtend';

import { currentLocale } from '@trello/locale';

const PluginOptions = (baseOptions) =>
  xtend(baseOptions, { locale: currentLocale });

export { PluginOptions };
